import * as React from "react";

const SvgLocation = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 700 700"
    style={{
      enableBackground: "new 0 0 700 700",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path d="M345.1 655.9c-6.1-2.9-11.3-7.5-14.8-13.3-57-80.7-114.5-161.1-171.2-242.1-21.6-31.1-34.7-67.3-37.9-105-9.6-98.2 43.5-192.7 133.6-231.6 87.4-37.9 170-26.3 243.9 34.3 22.3 18.1 40.8 40.5 54.4 65.7 13.6 25.3 22.1 53 25 81.6 7.3 57.4-7.7 115.4-42 162-55.2 77.7-110.4 155.6-165.7 233.7-3.6 6.4-9.1 11.5-15.7 14.7h-9.6zm81.4-382.8c.1-20.3-7.9-39.7-22.1-54.1-14.2-14.4-33.6-22.6-53.9-22.8-20.3-.2-39.8 7.7-54.2 21.9-14.5 14.2-22.7 33.5-23 53.8-.3 20.3 7.5 39.8 21.6 54.3 14.1 14.5 33.4 22.9 53.7 23.2 20.5.2 40.2-7.7 54.8-22 14.6-14.3 22.9-33.8 23.1-54.3z" />
  </svg>
);

export default SvgLocation;
